module.exports = __webpack_public_path__ + "static/media/cartBlack.8520f70b.svg";